module.exports = __webpack_public_path__ + "media/images/rlv-logo-64b61a0f938ef6adb45c73f05b6c309e.png";